import { useEffect } from 'react';
import { AuthView } from '@daveyplate/better-auth-ui';
import { useNavigate } from 'react-router-dom';
import { Card, Row, Logo } from 'components/lib';
import { SIGN_UP_EMAIL_KEY } from '../../../app/auth';

type SigninProps = Record<string, never>;

export function Signin(_props: SigninProps) {
  const navigate = useNavigate();

  useEffect(() => {
    const signUpEmail = sessionStorage.getItem(SIGN_UP_EMAIL_KEY);

    if (signUpEmail) {
      sessionStorage.removeItem(SIGN_UP_EMAIL_KEY);
      navigate('/register/verify', {
        replace: true,
        state: { signUpEmail },
      });
    }
  }, [navigate]);

  return (
    <Row title="Login to" customClass="auth-form-row">
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          marginBottom: '15px',
        }}
      >
        <Logo linked={false} />
      </div>

      <Card restrictWidth center extraClass="form-container" isStat={true}>
        <AuthView
          view="SIGN_IN"
          redirectTo="/login"
          className="um-login-auth max-w-none border-0 bg-transparent !py-3 shadow-none gap-3"
          classNames={{
            form: {
              forgotPasswordLink: 'underline underline-offset-2',
              error: '!text-red-600 !text-[13px]',
              input: 'border-0 bg-white/35 placeholder:text-black/20',
              primaryButton:
                'cursor-pointer rounded-full border border-black bg-transparent text-current hover:bg-transparent',
            },
            footerLink: 'cursor-pointer',
          }}
          localization={{
            SIGN_UP: 'Register',
            SIGN_IN: '',
          }}
        />
      </Card>
    </Row>
  );
}
